import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IapmDTO } from '@home/submodulos/dados-meteorologicos/interfaces';
import * as Highcharts from 'highcharts/highstock';
import { Chart } from 'highcharts';
import { optionsChartIapm } from '@home/submodulos/dados-meteorologicos/componentes/relatorios/grafico-iapm/chart-options';
import { COR_REGIAO_INDIVIDUAL } from '../../../utils';

@Component({
	selector: 'seira-grafico-iapm',
	templateUrl: './grafico-iapm.component.html',
	styleUrls: ['./grafico-iapm.component.scss'],
})
export class GraficoIapmComponent {
	@Input() dados!: IapmDTO[];
	@Input() fileName = '';
	@Input() chartTitle = '';
	@Input() columnColor?: string;

	isLoading = false;
	chart?: Highcharts.Chart;
	chartOptions = optionsChartIapm();

	@Output() chartInstance = new EventEmitter<Chart>();

	onChartCreated(chart: Chart) {
		this.chart = chart;

		// Atualiza direto no gráfico: título e remove botão sanduíche
		this.chart.update(
			{
				title: {
					text: this.chartTitle,
				},
				exporting: {
					enabled: false,
					buttons: {
						contextButton: {
							enabled: false,
						},
					},
					filename: this.fileName,
				},
			},
			true,
			true
		);

		this.chartInstance.emit(chart);

		this.setSeries();
	}

	setSeries() {
		this.chart?.series.forEach(el => el.remove());

		this.chart?.addSeries({
			type: 'column',
			name: 'IAPM',
			color: COR_REGIAO_INDIVIDUAL,
			pointPadding: 0.2,
			data: this.dados.map(dado => ({
				y: parseFloat(Number(dado.iapm).toFixed(1)),
				name: dado.periodo,
				category: dado.periodo,
			})),
		});
	}
}
